/* Copyright (c) 2021-2026, NVIDIA CORPORATION.  All rights reserved.
*
* NVIDIA CORPORATION and its licensors retain all intellectual property
* and proprietary rights in and to this software, related documentation
* and any modifications thereto.  Any use, reproduction, disclosure or
* distribution of this software and related documentation without an express
* license agreement from NVIDIA CORPORATION is strictly prohibited.
*/

/** This file was automatically generated. DO NOT MODIFY IT BY HAND. */

/* eslint-disable @typescript-eslint/naming-convention */

import { BridgeCommands } from '../../../src/bridge.commands';

import { Types } from '../../types/index';

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const Read: BridgeCommands.Command<
    Types.Common.Sharedstorage.ReadParameters,
    Types.Common.Sharedstorage.ReadReturn
    > = {
    legacyCommand: 'QUERY_READ_SHARED_STORAGE',
    system: 'CrimsonNative',
    module: 'SharedStorage',
    method: 'Read',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const Write: BridgeCommands.Command<
    Types.Common.Sharedstorage.WriteParameters,
    boolean
    > = {
    legacyCommand: 'QUERY_WRITE_SHARED_STORAGE',
    system: 'CrimsonNative',
    module: 'SharedStorage',
    method: 'Write',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const Remove: BridgeCommands.Command<
    Types.Common.Sharedstorage.RemoveParameters,
    boolean
    > = {
    legacyCommand: 'QUERY_REMOVE_FROM_SHARED_STORAGE',
    system: 'CrimsonNative',
    module: 'SharedStorage',
    method: 'Remove',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const Cache: BridgeCommands.Command<
    {},
    Types.Common.Sharedstorage.CacheReturn
    > = {
    legacyCommand: 'QUERY_CACHE_SHARED_STORAGE',
    system: 'CrimsonNative',
    module: 'SharedStorage',
    method: 'Cache',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const PostCacheUpdate: BridgeCommands.Command<
    Types.Common.Sharedstorage.PostCacheUpdateParameters,
    void
    > = {
    legacyCommand: 'QUERY_POST_CACHE_UPDATE_SHARED_STORAGE',
    system: 'CrimsonNative',
    module: 'SharedStorage',
    method: 'PostCacheUpdate',
    persistent: false
};

export const Sharedstorage = {
Read,
Write,
Remove,
Cache,
PostCacheUpdate
};
